module.exports = __webpack_public_path__ + "img/eliminar.8255a443.svg";